import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  showMap: {
    id: 'views.Departments.DepartmentsList.heading.showMap',
    defaultMessage: 'pokaż na mapie'
  }
});



// WEBPACK FOOTER //
// ./src/common/components/DepartmentsList/DepartmentsList.intl.js